import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { CfcModel } from '@models/gestao/cfc.model';
import { ServicesSubject } from '@services/outros/services-subjects.service';
import { UserControllerService } from '@services/outros/user-controller.service';
import { MenuService } from '@core/services/outros/menu.service';
import { InstrutorAgendamentoModel } from '@core/models/agendamento/instrutor-agendamento.model';
import { Helper } from '@core/utils/helper';
import { OrganizationModel } from '@core/models/agendamento-pratico/organization.model';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {

  private _subscription: Subscription;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _servicesSubject: ServicesSubject,
    private _userControllerService: UserControllerService,
    private _menuService: MenuService,
  ) {
    this._subscription = new Subscription();
  }

  ngOnInit(): void {
    this._subscription.add(
      this._activatedRoute.params.subscribe(
        () => {

          let cfcs: CfcModel[] = this._activatedRoute.snapshot.data['cfcs'];
          let organizations: OrganizationModel[] = this._activatedRoute.snapshot.data['organization'];

          const cfcLogged = cfcs.filter(x => x.cnpj == this._userControllerService.getUserLogged().organizationCNPJ);
          const user = this._userControllerService.getUserLogged();
          user.cfc = cfcLogged[0];
          this._userControllerService.setUser(user);
          this._userControllerService.setCfc(cfcLogged[0]);

          if (!this._userControllerService.isAdmin()) {
            cfcs = cfcLogged;
            organizations = organizations.filter(x => x.registerNumber == this._userControllerService.getUserLogged().organizationCNPJ);
          }

          let instrutoresAgendamento: InstrutorAgendamentoModel[] = this._activatedRoute.snapshot.data['instrutoresAgendamento'];
          instrutoresAgendamento.map(x => x.instrutorNome = `${x.instrutorNome} - ${x.cfcNome}`);

          //RESOLVERS GESTÃO
          this._servicesSubject.setCategoria(this._activatedRoute.snapshot.data['categoria']);
          this._servicesSubject.setCfc(cfcs);
          this._servicesSubject.setDelegacia(this._activatedRoute.snapshot.data['delegacias']);
          this._servicesSubject.setGrupo(this._activatedRoute.snapshot.data['grupo']);
          this._servicesSubject.setInstrutor(this._activatedRoute.snapshot.data['instrutores']);
          this._servicesSubject.setLocalFotoBiometria(this._activatedRoute.snapshot.data['localFotoBiometria']);
          this._servicesSubject.setLocal(Helper.sortItems(this._activatedRoute.snapshot.data['locais'], 'descricao'));
          this._servicesSubject.setProvedor(this._activatedRoute.snapshot.data['provedor']);
          this._servicesSubject.setRegiao(this._activatedRoute.snapshot.data['regioes']);
          this._servicesSubject.setServicos(this._activatedRoute.snapshot.data['servicos']);
          this._servicesSubject.setTipoExame(this._activatedRoute.snapshot.data['tipoExames']);
          this._servicesSubject.setUnidadeDetran(this._activatedRoute.snapshot.data['unidadeDetran']);
          this._servicesSubject.setVeiculo(this._activatedRoute.snapshot.data['veiculos']);
          this._servicesSubject.setVeiculoCfc(this._activatedRoute.snapshot.data['veiculosCfc']);

          //TEÓRICO
          this._servicesSubject.setCfcAgendamento(this._activatedRoute.snapshot.data['cfcsAgendamento']);
          this._servicesSubject.setCursoAgendamento(this._activatedRoute.snapshot.data['cursosAgendamento']);
          this._servicesSubject.setConteudoProgramatico(this._activatedRoute.snapshot.data['conteudoProgramatico']);
          this._servicesSubject.setInstrutorAgendamento(instrutoresAgendamento);
          this._servicesSubject.setServicoAgendamento(this._activatedRoute.snapshot.data['servicosAgendamento']);

          //FINANCEIRO
          this._servicesSubject.setContaCorrente(this._activatedRoute.snapshot.data['contas']);
          this._servicesSubject.setGrupoFinanceiro(this._activatedRoute.snapshot.data['grupoFinanceiro']);
          this._servicesSubject.setGrupoLancamento(this._activatedRoute.snapshot.data['grupoLancamento']);
          this._servicesSubject.setTipoLancamento(this._activatedRoute.snapshot.data['tipoLancamento']);
          this._servicesSubject.setPessoa(this._activatedRoute.snapshot.data['pessoa']);
          this._servicesSubject.setProdutos(this._activatedRoute.snapshot.data['produtos']);

          //PRÁTICO
          this._servicesSubject.settAvailabilityTimeCollection(this._activatedRoute.snapshot.data['availabilityTimeCollection']);
          this._servicesSubject.setInstrutorPratico(this._activatedRoute.snapshot.data['instructor']);
          this._servicesSubject.setOrganization(organizations);
          this._servicesSubject.setVeiculoPratico(this._activatedRoute.snapshot.data['vehicle']);
        }
      )
    );
    this._menuService.setMenu();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

}
